/* eslint-disable */

<template>
  <div class="b-login-container">
    <h1>Kuvera Admin Kyc Verification</h1>
    <div v-if="!admin" class="b-login-container__google-signin">
      <div class="google-btn" @click="authenticate('google')">
        <div class="google-icon-wrapper">
          <img
            class="google-icon"
            src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
          />
        </div>
        <p class="btn-text">
          <b>Sign in with google</b>
        </p>
      </div>
    </div>
    <div v-else>
      <h3>Already SIGNED-IN</h3>
      <button
        class="btn in-btn-google"
        @click="$router.push({ name: 'dashboard'})"
      >Start Verifying</button>
    </div>
  </div>
</template>

<script>

import { mapActions } from "vuex";
import { mapState, mapGetters } from "vuex";
export default {
  methods: {
    ...mapActions(["adminLogIn"]),
    authenticate(provider) {
      this.adminLogIn({ provider, route: this.$router }).then(() => {
         this.$router.push({ name: 'dashboard'});
      });
    }
  },
  computed: mapState({ admin: state => state.kycLogin.admin ,
  admin_partner: state => state.kycLogin.admin_partner}),
  // ...mapGetters(['admin_partner']),
  // @click="$router.push({ name: 'kyc-details', params: {status: 'Pending', partner: admin_partner}})"
};
</script>


<style scoped lang="scss">
.b-login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 51px;
}

.b-login-container__google-signin {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.in-btn-google {
  height: 46px;
  width: 287.7px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid transparent;
  background-color: #dd4c3a;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  margin-top: 60px;
}

.b-login-container h1,
h3 {
  text-align: center;
}
.google-btn {
  width: 200px;
  height: 42px;
  margin-top: 25px;
  background-color: #4285f4;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
  cursor: pointer;
  .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: #fff;
  }
  .google-icon {
    position: absolute;
    margin-top: 11px;
    margin-left: 11px;
    width: 18px;
    height: 18px;
  }
  .btn-text {
    float: right;
    margin: 12px 18px 0 0;
    color: #fff;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
  }
  &:hover {
    box-shadow: 0 0 6px #4285f4;
  }
  &:active {
    background: #1669f2;
  }
}
</style>
